<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import FormattedContent from './Text/FormattedContent.vue';
import { useMessageContext } from '../provider';
import { unavailableMedia, mediaSummary } from 'dashboard/helper/unavailableMedia';
const { content, contentAttributes } = useMessageContext();
const data = computed(() => ({ contentAttributes: contentAttributes.value }));
const media = computed(() => unavailableMedia(data.value));
const title = computed(() => mediaSummary(data.value));
const icons = { image: '🖼', video: '🎬', audio: '🎧', file: '📎', sticker: '▧', message: '💬' };
const details = computed(() => {
  const m = media.value || {};
  const parts = [];
  if (m.size > 0) parts.push(m.size >= 1048576 ? `${(m.size / 1048576).toFixed(1)} MB` : `${Math.ceil(m.size / 1024)} KB`);
  if (m.duration > 0) parts.push(`${Math.floor(m.duration / 60)}:${String(Math.floor(m.duration % 60)).padStart(2, '0')}`);
  return parts.join(' · ');
});
</script>
<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="unavailable-media">
    <div class="flex flex-col gap-2 max-w-80">
      <FormattedContent v-if="content" :content="content" />
      <div class="rounded-lg border border-n-strong bg-n-alpha-1 p-3" role="note">
        <div class="flex gap-2 items-start font-medium text-sm">
          <span aria-hidden="true">{{ icons[media?.kind] || '📎' }}</span>
          <span>{{ title }}</span>
        </div>
        <p v-if="media?.filename" class="m-0 mt-2 text-xs break-all">{{ media.filename }}</p>
        <p v-if="details" class="m-0 mt-1 text-xs text-n-slate-11">{{ details }}</p>
        <p class="m-0 mt-2 text-xs leading-5 text-n-slate-11">{{ media?.reason === 'processing' ? '文件接收完成后将自动显示，请稍候。' : '文件尚未接收成功，原文件仍可到 WhatsApp 原聊天中查找。' }}</p>
      </div>
    </div>
  </BaseBubble>
</template>
